import getProfileRoute from "./get-profile-route";
import updateProfileRoute from "./update-profile-route";
import getAssociatesRoute from "./get-associates-route";
import setShowOnProfile from "./set-show-on-profile-route";
import getPublicProfileRoute from "./get-public-profile-route";

export default {
  "get-profile": getProfileRoute,
  "get-public-profile": getPublicProfileRoute,
  "update-profile": updateProfileRoute,
  "get-associates": getAssociatesRoute,
  "set-show-on-profile": setShowOnProfile,
};
